import { useContext } from 'react';
import { useGetOperators } from './useGetOperators';
import { Map as ImmutableMap } from 'immutable';
import { ENUMERATION } from 'customer-data-objects/property/PropertyTypes';
import { __ANY_PAGE } from 'customer-data-filters-ui/converters/listSegClassic/ListSegConstants';
import { FORM } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import Equal from 'customer-data-filters-ui/filterQueryFormat/operator/Equal';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import { EVENT_BASED_FIELD_KEYS, getBaseEventBasedFilterFamilyField, getEventBasedFilterFamilyFields, getRefinementCondition } from '../strategy/eventBasedFilters';
export const useFormSubmissionFilter = (condition, onChange) => {
  const {
    data
  } = useContext(SegmentationFiltersInstanceContext);
  const formSubmissionFields = getEventBasedFilterFamilyFields(FORM, data, condition);
  const {
    getRefinementOperators
  } = useGetOperators();
  const statusCondition = condition.set('field', getBaseEventBasedFilterFamilyField(FORM));
  const pageField = formSubmissionFields.get(EVENT_BASED_FIELD_KEYS.EVENT_PAGE);
  const pageCondition = condition.value !== __ANY_PAGE || condition.isPageSelected ? Equal.of(pageField, condition.value) : undefined;
  const dateRefinementCondition = getRefinementCondition(FORM, condition.dateRefinement);
  const numberRefinementCondition = getRefinementCondition(FORM, condition.numberRefinement);
  const onPageChange = formSubmissionPageCondition => {
    const newCondition = condition.merge({
      value: formSubmissionPageCondition.get('value'),
      isPageSelected: true
    });
    onChange(newCondition);
  };
  const onPageDelete = () => {
    const newCondition = condition.merge({
      value: __ANY_PAGE,
      isPageSelected: false
    });
    onChange(newCondition);
  };
  const getRefinementsWithEmptyValue = refinementFields => {
    return refinementFields.map(field => {
      var _operators$first;
      if (field.type === ENUMERATION) {
        return Equal.of(field);
      }
      const operators = getRefinementOperators(FORM, field);
      return operators === null || operators === void 0 || (_operators$first = operators.first()) === null || _operators$first === void 0 ? void 0 : _operators$first.of(field);
    });
  };
  const refinementFields = getEventBasedFilterFamilyFields(FORM, ImmutableMap(), condition, true);
  const refinementConditionsEmptyValue = getRefinementsWithEmptyValue(refinementFields.toArray());
  return {
    statusCondition,
    pageCondition,
    dateRefinementCondition,
    numberRefinementCondition,
    refinementConditionsEmptyValue,
    onPageChange,
    onPageDelete
  };
};